import { Tabs } from 'antd';

import { useAppSelector } from 'app/store';

import { viewerModel } from 'entities/viewer';

import { RolesUser } from 'shared/enums';
import { configTabs } from 'shared/helpers/utils';
import { useTabsNavigate } from 'shared/hooks';
import { TItemsTab } from 'shared/types/types';

import { ConsultationsArchive } from './consultationsArchive';
import { ConsultationsArchiveOther } from './consultationsArchiveOther';
import { ConsultationsInProgress } from './consultationsInProgress';
import { ConsultationsPull } from './consultationsPull';
import ConsultationSubordinates from './consultationSubordinates';
import style from './index.module.scss';

const itemsTab: TItemsTab = [
  {
    label: 'Общий список заявок',
    key: 'new',
    children: <ConsultationsPull />,
    role: [RolesUser.HRDirector, RolesUser.Consultant],
  },
  {
    label: 'Подчинённые',
    key: 'other',
    children: <ConsultationSubordinates />,
    role: [RolesUser.HRDirector, RolesUser.SecondLine],
  },
  {
    label: 'В работе',
    key: 'my',
    children: <ConsultationsInProgress />,
    role: [RolesUser.HRDirector, RolesUser.Consultant],
  },
  {
    label: 'Архив',
    key: 'myArchive',
    children: <ConsultationsArchive />,
    role: [RolesUser.HRDirector, RolesUser.Consultant],
  },
  {
    label: 'Архив подчинённых',
    key: 'subordinatesArchive',
    children: <ConsultationsArchiveOther />,
    role: [RolesUser.HRDirector, RolesUser.SecondLine],
  },
];

const Consultations = () => {
  const [activeTab, handler] = useTabsNavigate('consultations', itemsTab[0].key);
  const { role } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const tabPane = configTabs(role, itemsTab);

  return (
    <div className={style.wrap}>
      {role && (
        <Tabs activeKey={activeTab} onChange={handler} destroyInactiveTabPane>
          {tabPane &&
            tabPane?.map(el => {
              return (
                <Tabs.TabPane tab={el.label} key={el.key}>
                  {el.children}
                </Tabs.TabPane>
              );
            })}
        </Tabs>
      )}
    </div>
  );
};

export default Consultations;
